var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoMicrosoftExcel = function SvgLogoMicrosoftExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.458 0h3.285v4.444c5.535 0 11.07.012 16.605-.016.934.039 1.963-.028 2.776.533.57.822.503 1.867.542 2.811-.028 9.645-.017 19.284-.011 28.922-.028 1.617.149 3.267-.188 4.862-.221 1.155-1.604 1.183-2.527 1.222-5.729.016-11.463-.011-17.197 0v5h-3.434C16.882 46.238 8.439 44.817 0 43.333V4.45C8.488 2.967 16.976 1.506 25.458 0Z",
    fill: "#207245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.743 6.111H46.99v35H28.743v-3.333h4.423v-3.89h-4.423v-2.221h4.423v-3.89h-4.423v-2.221h4.423v-3.89h-4.423v-2.222h4.423v-3.888h-4.423v-2.223h4.423V9.444h-4.423V6.111Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.378 9.444h7.742v3.89h-7.742v-3.89Z",
    fill: "#207245"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.379 14.65c1.25-.089 2.505-.167 3.76-.228a1155.268 1155.268 0 0 1-4.463 9.106c1.521 3.11 3.075 6.2 4.601 9.31-1.333-.077-2.66-.16-3.992-.255-.94-2.316-2.085-4.555-2.76-6.977-.752 2.255-1.824 4.383-2.687 6.594-1.211-.017-2.422-.067-3.633-.117 1.421-2.794 2.793-5.61 4.258-8.388-1.244-2.862-2.61-5.667-3.893-8.512 1.217-.072 2.433-.144 3.65-.21.823 2.171 1.725 4.316 2.405 6.544.73-2.361 1.82-4.584 2.754-6.867Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.378 15.556h7.742v3.888h-7.742v-3.888ZM35.378 21.667h7.742v3.889h-7.742v-3.89ZM35.378 27.778h7.742v3.889h-7.742v-3.89ZM35.378 33.889h7.742v3.889h-7.742v-3.89Z",
    fill: "#207245"
  })));
};

export default SvgLogoMicrosoftExcel;